import { useState } from "react";

import { PublicationListSearchFilterType } from "@/components/business/PublicationListContainer/publicationList.types";

import { PUBLICATION_LIST_EDITOR_INFO_FILTER } from "./components/EditorInfoSearch/constants/editorInfoFilter.constants";
import EditorInfoSearch from "./components/EditorInfoSearch/EditorInfoSearch";
import { PUBLICATION_LIST_INFO_FILTER } from "./components/PublicationInfoSearch/constants/infoFilter.constants";
import PublicationInfoSearch from "./components/PublicationInfoSearch/PublicationInfoSearch";
import * as S from "./PublicationListSearch.style";

const PublicationListSearch = () => {
  const [currentPublicationFilter, setCurrentPublicationFilter] =
    useState<PublicationListSearchFilterType>(PUBLICATION_LIST_INFO_FILTER[0]);
  const [currentEditorFilter, setCurrentEditorFilter] =
    useState<PublicationListSearchFilterType>(
      PUBLICATION_LIST_EDITOR_INFO_FILTER[0],
    );

  return (
    <S.SearchWrapper>
      <PublicationInfoSearch
        currentPressFilter={currentPublicationFilter}
        setCurrentFilter={setCurrentPublicationFilter}
      />
      <EditorInfoSearch
        currentEditorFilter={currentEditorFilter}
        setCurrentFilter={setCurrentEditorFilter}
      />
    </S.SearchWrapper>
  );
};

export default PublicationListSearch;
